import { CreditCardInfo, Customer, SubscriptionStatus } from "./../../api/proxies";
import { actions } from ".";
import { createReducer, on } from "@ngrx/store";
import { ISubscriptionDetailsState } from "./model";
import { SubscriptionItem } from "../../api/proxies";
import { subscriptionCancelled } from "./actions";

export const SUBSCRIPTION_DETAILS_FEATURE_KEY = "subscriptionDetails";

export const subscriptionDetailsInitialState: ISubscriptionDetailsState = {
    customer: undefined,
    editionName: undefined,
    price: undefined,
    currentPrice: undefined,
    billingCycle: undefined,
    startDate: undefined,
    items: undefined,
    loading: false,
    isEditingCreditCard: false,
    status: undefined,
    billings: undefined,
    loadingActiveBillings: false,
};

export const subscriptionDetailsReducer = createReducer(
    subscriptionDetailsInitialState,
    on(actions.getSubscriptionDetails, (state) => ({
        ...state,
        loading: true,
    })),
    on(actions.getSubscriptionDetailsComplete, (state, { subscription }) => {
        let items = subscription.items
            .filter((item) => item.value === "True" || Number(item.value) > 0)
            .map((item) => {
                if (item.name === "Health.Features.Storage.Size") {
                    let sizeInGB = Number(item.value) / (1024 * 1024 * 1024);
                    return SubscriptionItem.fromJS({
                        ...item,
                        value: `${sizeInGB} GB`,
                    });
                }
                let returnValue = SubscriptionItem.fromJS(item);
                if (item.value === "2147483647") {
                    returnValue = SubscriptionItem.fromJS({
                        ...returnValue,
                        value: "Ilimitado",
                    });
                }

                return returnValue;
            });
        return {
            ...state,
            ...subscription,
            items,
            loading: false,
        };
    }),
    on(actions.getSubscriptionDetailsError, (state, { error }) => ({
        ...state,
        loading: false,
    })),
    on(actions.toggleCreditCardUpdate, (state) => ({
        ...state,
        isEditingCreditCard: !state.isEditingCreditCard,
    })),
    on(actions.updateCreditCard, (state) => ({
        ...state,
        loading: true,
    })),
    on(actions.updateCreditCardComplete, (state, { result, data }) => ({
        ...state,
        customer: Customer.fromJS({
            ...state.customer,
            creditCard: CreditCardInfo.fromJS({
                flag: data.flag,
                ownerName: data.ownerName,
                digits: data.number,
                expirationMonth: data.expirationMonth,
                expirationYear: data.expirationYear,
            }),
        }),
        loading: false,
        isEditingCreditCard: false,
    })),
    on(actions.updateCreditCardError, (state) => ({
        ...state,
        loading: false,
        isEditingCreditCard: false,
    })),
    on(actions.cancelSubscription, (state) => ({
        ...state,
        loading: true,
    })),
    on(actions.subscriptionCancelled, (state) => ({
        ...state,
        status: SubscriptionStatus.fromJS({ code: 71, date: state.status.date }),
        loading: false,
    })),
    on(actions.cancelSubscriptionError, (state) => ({
        ...state,
        loading: false,
    })),
    on(actions.abandonCancellation, (state) => ({
        ...state,
        loading: true,
    })),
    on(actions.abandonCancellationComplete, actions.abandonCancellationError, (state) => ({
        ...state,
        loading: false,
    })),
    on(actions.getActiveBillings, (state) => ({
        ...state,
        loadingActiveBillings: true,
    })),
    on(actions.getActiveBillingsComplete, (state, { billings }) => ({
        ...state,
        billings,
        loadingActiveBillings: false,
    })),
    on(actions.getActiveBillingsError, (state) => ({
        ...state,
        loadingActiveBillings: false,
    }))
);
